import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import PropTypes from 'prop-types';
import CustomPropTypes from '../../util/custom-prop-types';
export var SX_PROP_CONFIG = {
  alignContent: {
    proptype: [PropTypes.string]
  },
  alignItems: {
    proptype: [PropTypes.string]
  },
  alignSelf: {
    proptype: [PropTypes.string]
  },
  aspectRatio: {
    proptype: [PropTypes.string]
  },
  backgroundColor: {
    proptype: [PropTypes.string]
  },
  border: {
    proptype: [PropTypes.string]
  },
  borderColor: {
    proptype: [PropTypes.string],
    constituentProps: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor']
  },
  borderRadius: {
    proptype: [PropTypes.string],
    constituentProps: ['borderTopRightRadius', 'borderTopLeftRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius']
  },
  borderStyle: {
    proptype: [PropTypes.string]
  },
  borderWidth: {
    proptype: [PropTypes.string, PropTypes.number],
    constituentProps: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth']
  },
  bottom: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  boxShadow: {
    proptype: [PropTypes.string]
  },
  boxSizing: {
    proptype: [PropTypes.string]
  },
  color: {
    proptype: [PropTypes.string]
  },
  cursor: {
    proptype: [PropTypes.string]
  },
  display: {
    proptype: [PropTypes.string]
  },
  fill: {
    proptype: [PropTypes.string]
  },
  flex: {
    proptype: [PropTypes.string]
  },
  flexBasis: {
    proptype: [PropTypes.string]
  },
  flexDirection: {
    proptype: [PropTypes.string]
  },
  flexFlow: {
    proptype: [PropTypes.string]
  },
  flexGrow: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  flexShrink: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  flexWrap: {
    proptype: [PropTypes.string]
  },
  fontFamily: {
    proptype: [PropTypes.string]
  },
  fontSize: {
    proptype: [PropTypes.string]
  },
  fontStyle: {
    proptype: [PropTypes.string]
  },
  fontWeight: {
    proptype: [PropTypes.string]
  },
  gap: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  grid: {
    proptype: [PropTypes.string]
  },
  gridArea: {
    proptype: [PropTypes.string]
  },
  gridAutoColumns: {
    proptype: [PropTypes.string]
  },
  gridAutoFlow: {
    proptype: [PropTypes.string]
  },
  gridAutoRows: {
    proptype: [PropTypes.string]
  },
  gridColumn: {
    proptype: [PropTypes.string]
  },
  gridColumnEnd: {
    proptype: [PropTypes.string]
  },
  gridColumnGap: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  gridColumnStart: {
    proptype: [PropTypes.string]
  },
  gridGap: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  gridRow: {
    proptype: [PropTypes.string]
  },
  gridRowEnd: {
    proptype: [PropTypes.string]
  },
  gridRowGap: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  gridRowStart: {
    proptype: [PropTypes.string]
  },
  gridTemplate: {
    proptype: [PropTypes.string]
  },
  gridTemplateAreas: {
    proptype: [PropTypes.string]
  },
  gridTemplateColumns: {
    proptype: [PropTypes.string]
  },
  gridTemplateRows: {
    proptype: [PropTypes.string]
  },
  height: {
    proptype: [PropTypes.string]
  },
  justifyContent: {
    proptype: [PropTypes.string]
  },
  justifyItems: {
    proptype: [PropTypes.string]
  },
  justifySelf: {
    proptype: [PropTypes.string]
  },
  left: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  lineHeight: {
    proptype: [PropTypes.string]
  },
  margin: {
    proptype: [PropTypes.string, PropTypes.number],
    constituentProps: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft']
  },
  opacity: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  order: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  outline: {
    proptype: [PropTypes.string]
  },
  overflow: {
    proptype: [PropTypes.string]
  },
  padding: {
    proptype: [PropTypes.string, PropTypes.number],
    constituentProps: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft']
  },
  placeContent: {
    proptype: [PropTypes.string]
  },
  placeItems: {
    proptype: [PropTypes.string]
  },
  placeSelf: {
    proptype: [PropTypes.string]
  },
  position: {
    proptype: [PropTypes.string]
  },
  right: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  rowGap: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  stroke: {
    proptype: [PropTypes.string]
  },
  textAlign: {
    proptype: [PropTypes.string]
  },
  textDecoration: {
    proptype: [PropTypes.string]
  },
  textTransform: {
    proptype: [PropTypes.string]
  },
  textOverflow: {
    proptype: [PropTypes.string]
  },
  textShadow: {
    proptype: [PropTypes.string]
  },
  top: {
    proptype: [PropTypes.string, PropTypes.number]
  },
  transform: {
    proptype: [PropTypes.string]
  },
  transformOrigin: {
    proptype: [PropTypes.string]
  },
  transformStyle: {
    proptype: [PropTypes.string]
  },
  transition: {
    proptype: [PropTypes.string]
  },
  transitionTiming: {
    proptype: [PropTypes.string]
  },
  transitionProperty: {
    proptype: [PropTypes.string]
  },
  transitionTimingFunction: {
    proptype: [PropTypes.string]
  },
  userSelect: {
    proptype: [PropTypes.string]
  },
  verticalAlign: {
    proptype: [PropTypes.string]
  },
  visibility: {
    proptype: [PropTypes.string]
  },
  width: {
    proptype: [PropTypes.string]
  },
  zIndex: {
    proptype: [PropTypes.string, PropTypes.number]
  }
};
export var getSxPropTypes = function getSxPropTypes() {
  return Object.keys(SX_PROP_CONFIG).reduce(function (runner, current) {
    var setting = SX_PROP_CONFIG[current];
    var typeConcat = _toConsumableArray(setting !== null && setting !== void 0 && setting.proptype ? setting.proptype : []);
    var attrs = {};
    var value = CustomPropTypes.inlineMediaQuery(PropTypes.oneOfType(_toConsumableArray(typeConcat)));
    Object.defineProperty(attrs, current, {
      value: value
    });
    if (setting !== null && setting !== void 0 && setting.constituentProps && setting.constituentProps.length > 0) {
      setting.constituentProps.forEach(function (prop) {
        Object.defineProperty(attrs, prop, {
          value: value
        });
      });
    }
    return Object.keys(attrs).length > 0 ? Object.assign({}, runner, attrs) : Object.assign({}, runner);
  }, {});
};